module.exports = __webpack_public_path__ + "img/retour_green_icon.893246bf.svg";